let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ks76h")).then(() => parcelRequire('45V88'));